import React from 'react';

import Button from 'react-bootstrap/Button';
import {Col, Row, Image, InputGroup, Form, Container, Card} from "react-bootstrap";

function Features() {
    const InfoCol = (props: {title: any, children: any}) => {
        return (
            <Col sm={12} md={12} lg={4}>
                <Card style={{marginBottom: 40, minHeight: 450}}>
                    <Card.Body style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        <h4>{props.title}</h4>
                        <p>{props.children}</p>
                    </Card.Body>
                </Card>
            </Col>
        );
    }

    return (
        <Container style={{marginTop: 100, padding: 20}}>
            <Row className={'justify-content-center'}>
               <InfoCol title={"Streamline Your Drafting Process with AI"}>
               Our legal drafting contract app is the perfect solution for anyone looking to streamline their drafting process. Powered by AI technology, our app is able to analyze your input and provide suggestions for clauses that you may have overlooked. This not only saves time but also reduces the risk of errors or omissions in your contracts.
               </InfoCol>

                <InfoCol title={"Stay Compliant with the Latest Legal Requirements"}>
                With our app, you can rest assured that your contracts are accurate and up-to-date. Our AI technology continuously monitors legal updates and alerts you when changes are made to relevant laws and regulations.
                </InfoCol>

                <InfoCol title={"User-Friendly Legal Drafting "}>
                Finally, our legal drafting contract app is user-friendly and easy to navigate. You don't need any legal expertise to use it. Simply input your requirements, and our app will do the rest. We are confident that our app will revolutionize the way you draft contracts and help you save time and money in the process.
                </InfoCol>
            </Row>
        </Container>
    );
}

export default Features;
